import React, { useEffect, useState } from "react";
import { Navbar, Footer } from "../hrcomponents";
import axios from "axios";
import configData from "../config.json";
import * as Icon from "react-bootstrap-icons";
import { format } from "date-fns";
import { leaves } from "../utils/datalist";
import Select from "react-select";
import {useParams,Link,useNavigate, useLocation} from 'react-router-dom';

const Leave = () => {
  if (localStorage.getItem("branchID") === null) {
    window.location.replace("/hris");
  }

  const navigate=useNavigate();
  const location = useLocation();

  const [empData, setEmpData] = useState([]);
  const [inputData, setInputData] = useState({});
  const [leaveData, setLeaveData] = useState([]);
  const [empID, setEmpId] = useState("");

  const handleInput = (e) => {
    const { name, value } = e.target;

    setInputData({
      ...inputData,
      [name]: value,
    });
  };

  useEffect(() => {
    const getEmpData = async () => {
      try {
        const response = await axios.get(
          configData.SERVER_URL +
            `/empData/${localStorage.getItem("branchID")}`
        );

        setEmpData(response.data);
      } catch (error) {
        console.log(error);
      }
    };

    getEmpData();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!inputData.dateFrom || !inputData.dateTo) {
      alert("Both dates are required.");
      return;
    }

    if (inputData.dateFrom > inputData.dateTo) {
      alert("Invalid Date Selection...");
      return;
    }

    const payload = {
      ...inputData,
      empID: empID,
    };

    try {
      const verify = await axios.post(
        configData.SERVER_URL + `/leaveVerify`,
        payload
      );

      if (verify.data[0].aCount === 0) {
        const res = await axios.post(
          configData.SERVER_URL + `/leaveEntry`,
          payload
        );

        setLeaveData(res.data);

        if (res.status === 200) {
          alert("Successfully Inserted");
        } else {
          alert("System Error");
        }
      } else {
        alert("Wrong Leave Posting....");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const empOptions = empData.map((d) => ({
    value: String(d.id),
    label: `${d.empCode} | ${d.empName} | ${d.NID}`,
  }));

  return (
    <>
      <div
        className="container" >
        {/* Main Form Card */}
        <div
          className="card shadow-lg border-0 mb-4"
          style={{
            borderRadius: "18px",
            overflow: "hidden",
          }}
        >
          {/* Header */}
          <div
            className="card-header"
            style={{
              background:
                "linear-gradient(135deg, #0d6efd, #0dcaf0)",
              color: "#fff",
              padding: "20px",
            }}
          >
            <div className="d-flex align-items-center">
              <Icon.CalendarCheck
                size={28}
                className="me-2"
              />

              <div>
                <h3 className="mb-0 fw-bold">
                  Leave Entry
                </h3>

                <small>
                  Employee leave management system
                </small>
              </div>
            </div>
          </div>

          {/* Body */}
          <div
            className="card-body"
            style={{
              backgroundColor: "#f8f9fa",
              padding: "30px",
            }}
          >
            <div className="row g-4">
              {/* Employee */}
              <div className="col-lg-9 col-md-12">
                <label className="form-label fw-semibold"> Employee</label>

                <Select options={empOptions} isSearchable 
                placeholder="Search Employee..."
                menuPortalTarget={document.body}
                  menuPosition="fixed"
                  onChange={(selectedOption) => {setEmpId( selectedOption ? selectedOption.value: null );}}
                //   styles={{
                //     control: (base) => ({
                //       ...base,
                //       minHeight: "45px",
                //       borderRadius: "10px",
                //     }),
                //   }}
                />
              </div>

              {/* Leave Code */}
              <div className="col-lg-3 col-md-6">
                <label className="form-label fw-semibold"> Leave Type</label>

                <select
                  className="form-select shadow-sm" id="leaveCode" name="leaveCode"
                  onChange={handleInput} 
                  style={{ height: "45px", borderRadius: "10px",}}
                >
                  <option value="">--- Select ---</option>

                  {leaves.map((leave) => (
                    <option key={leave.id} value={leave.code}>
                      {leave.name}
                    </option>
                  ))}
                </select>
              </div>

              {/* Date From */}
              <div className="col-lg-3 col-md-6">
                <label className="form-label fw-semibold">
                  Date From
                </label>

                <input
                  type="date"
                  className="form-control shadow-sm"
                  name="dateFrom"
                  onChange={handleInput}
                  style={{
                    height: "45px",
                    borderRadius: "10px",
                  }}
                />
              </div>

              {/* Date To */}
              <div className="col-lg-3 col-md-6">
                <label className="form-label fw-semibold">
                  Date To
                </label>

                <input
                  type="date"
                  className="form-control shadow-sm"
                  name="dateTo"
                  onChange={handleInput}
                  style={{
                    height: "45px",
                    borderRadius: "10px",
                  }}
                />
              </div>

              {/* Button */}
              <div className="col-lg-3 col-md-6 d-flex align-items-end">
                <button
                  type="button"
                  className="btn btn-success w-100 shadow-sm"
                  onClick={handleSubmit}
                  style={{ height: "45px", borderRadius: "10px", fontWeight: "600", fontSize: "15px", }}
                  disabled={location?.state?.menu?.isInsert !== "Y"}
                >
                  <Icon.SendCheck
                    className="me-2"
                    size={18}
                  />
                  POST LEAVE
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Leave Details Card */}
        <div
          className="card shadow-lg border-0"
          style={{
            borderRadius: "18px",
            overflow: "hidden",
          }}
        >
          {/* Header */}
          <div
            className="card-header d-flex justify-content-between align-items-center"
            style={{
              background:
                "linear-gradient(135deg, #198754, #20c997)",
              color: "#fff",
              padding: "18px 20px",
            }}
          >
            <h5 className="mb-0 fw-bold">
              Leave Details
            </h5>

            <span className="badge bg-light text-dark px-3 py-2">
              Total : {leaveData?.length || 0}
            </span>
          </div>

          {/* Table */}
          <div
            className="card-body"
            style={{
              backgroundColor: "#fff",
            }}
          >
            <div className="table-responsive">
              <table className="table table-hover table-bordered align-middle">
                <thead
                  style={{
                    backgroundColor: "#198754",
                    color: "#fff",
                  }}
                >
                  <tr>
                    <th>#</th>
                    <th>Date From</th>
                    <th>Date To</th>
                    <th>Leave Code</th>
                  </tr>
                </thead>

                <tbody>
                  {leaveData &&
                    leaveData.length > 0 &&
                    leaveData.map((data, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>

                        <td>
                          {format(
                            new Date(data.dateFrom),
                            "dd-MM-yyyy"
                          )}
                        </td>

                        <td>
                          {format(
                            new Date(data.dateTo),
                            "dd-MM-yyyy"
                          )}
                        </td>

                        <td>
                          <span className="badge bg-primary px-3 py-2">
                            {data.leaveCode}
                          </span>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>

              {leaveData.length === 0 && (
                <div className="alert alert-warning text-center mt-3">
                  No leave records found.
                </div>
              )}
            </div>
          </div>
        </div>

      </div>
    </>
  );
};

export default Leave;